import './offer-card-footer-buttons.scss';
import IOfferCardFooterButtonsProps from './IOfferCardFooterButtonsProps';
import OfferCardDetails from '../offer-card-details/offer-card-details';
import OfferCardAcceptButton from '../offer-card-accept-button/offer-card-accept-button';
import OfferCardConfirmButton from '../offer-card-confirm-button/offer-card-confirm-button';
import { useOffersRound } from '../../../../../app/contexts/offers-round/offers-round.context';

export default function OfferCardFooterButtons({
    offer,
    isConfirmationEnabled = true,
}: Readonly<IOfferCardFooterButtonsProps>) {
    const { roundState } = useOffersRound();

    return (
        <div className="offer-card-footer-buttons">
            <div className="offer-card-footer-button">
                {roundState.currentPhase === 'Acceptance' && (
                    <OfferCardAcceptButton offer={offer} />
                )}
                {roundState.currentPhase === 'Confirmation' && (
                    <OfferCardConfirmButton
                        offer={offer}
                        isConfirmationEnabled={isConfirmationEnabled}
                    />
                )}
            </div>

            <div className="offer-card-footer-button-icon">
                <OfferCardDetails offer={offer} />
            </div>
        </div>
    );
}
